/* Dev logger utility — use in components to centralize console usage.
   Keeps ESLint `no-console` happy because the implementation is locally
   eslint-disabled.

   Default: SILENT in dev (it was too noisy — step-trace logs were firing
   on every render). Errors still print so genuine problems aren't hidden.

   To turn the firehose back on while debugging, run in DevTools:
     localStorage.setItem('pioneer_debug', '1')   // log/info/warn/debug all on
     localStorage.removeItem('pioneer_debug')     // back to silent

   In production builds nothing prints regardless of the flag, except errors. */
import { config } from '@/infra/config';

function debugEnabled(): boolean {
  if (!config.isDevelopment) return false;
  try {
    return typeof window !== 'undefined'
      && window.localStorage?.getItem('pioneer_debug') === '1';
  } catch {
    return false;
  }
}

/* eslint-disable no-console */
const devLogger = {
  log: (...args: unknown[]): void => { if (debugEnabled()) console.log(...args); },
  info: (...args: unknown[]): void => { if (debugEnabled()) console.info(...args); },
  warn: (...args: unknown[]): void => { if (debugEnabled()) console.warn(...args); },
  // Errors always print in development so real bugs aren't swallowed.
  error: (...args: unknown[]): void => { if (config.isDevelopment) console.error(...args); },
  debug: (...args: unknown[]): void => { if (debugEnabled()) console.debug(...args); },
};
/* eslint-enable no-console */

export default devLogger;
